// JS mirror of tokens.css for the few places that need raw values (charts, canvas, inline styles).
// In styles, prefer the CSS variables: var(--rc-surface-1), var(--rc-text-2) and so on.

export const COLORS = Object.freeze({
  bg: '#000000',
  surface1: '#181818',
  surface2: '#1F1F1F',
  surface3: '#272727',
  surface4: '#313131',
  line: '#272727',
  lineStrong: '#313131',
  text: '#FFFFFF',
  text2: '#9B9B9B',
  text3: '#666666',
  red: '#E42545',
  green: '#37BE7A',
  amber: '#E6A433',
});

// Chart series: the red accent first, then neutrals that stay readable on black.
export const CHART_SERIES = Object.freeze(['#E42545', '#FFFFFF', '#9B9B9B', '#666666', '#37BE7A', '#E6A433']);

export const FONT = "'Geist Variable', 'Geist', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif";
export const MONO = "'Geist Mono Variable', 'Geist Mono', ui-monospace, SFMono-Regular, Menlo, monospace";
// The slab viewer's condensed face for page titles and big numbers; pair with fontStretch: DISPLAY_STRETCH.
export const DISPLAY = "'Archivo Variable', 'Archivo', 'Arial Narrow', " + FONT;
export const DISPLAY_STRETCH = '72%';

export const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
export const MOVE_MS = 500;
export const FADE_MS = 300;

// Tailwind type scale as [size, lineHeight] in px.
export const TYPE = Object.freeze({
  xs: [12, 16], sm: [14, 20], base: [16, 24], lg: [18, 28], xl: [20, 28],
  '2xl': [24, 32], '3xl': [30, 36], '4xl': [36, 40], '5xl': [48, 48], '7xl': [72, 72],
});

export const SPACE = Object.freeze([0, 2, 4, 8, 12, 16, 24, 32, 40, 48, 64, 80, 96]);
export const RADIUS = Object.freeze({ none: 0, sm: 2, base: 4, md: 6, lg: 8, xl: 12, '2xl': 16, '3xl': 24, full: 9999 });
